import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH, () => {
  const requestId = 'listAllNotifications-' + Date.now();
  bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.NOTIFICATION.GET_LIST,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.NOTIFICATION.UPDATE, saveNotification);
bus.on(constants.EVENTS.NOTIFICATION.SUBMIT, saveNotification);
bus.on(constants.EVENTS.NOTIFICATION.DELETE, (data) =>
  saveNotification({ ...data, action: 'delete' })
);

async function saveNotification(data) {
  const requestId = 'saveNotification-' + Date.now();
  const isDelete = data.action === 'delete';
  const method = isDelete ? 'DELETE' : 'POST';
  
  // Determine ID (data.id usually looks like 'notif-12345678')
  const notifId = data.id ? data.id.replace('notif-', '') : Date.now();
  const url = constants.ENDPOINTS.NOTIFICATION.UPDATE.replace('{timestamp}', notifId);

  bus.emit(constants.EVENTS.LOADING.START);

  // 1. PUSH Notification (only for new creations, not edits or deletes)
  if (!isDelete && !data.id) {
    const pushData = {
      title: data.title,
      content: data.description,
      service: '1bpay'
    };
    if (data.country && data.country !== 'ANY') {
      pushData.country = data.country;
    }
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: 'push-' + requestId,
      url: constants.ENDPOINTS.NOTIFICATION.PUSH,
      method: 'POST',
      data: pushData
    });
  }

  // 2. SAVE to Database
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: url,
    method: method,
    data: isDelete ? {} : serializer.serialize(data)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      // Pour une suppression, on ne parse pas avec le serializer de list, on verifie juste le status
      const success = res.data?.statusCode === 200 || res.data?.statusCode === 201;
      bus.emit(constants.EVENTS.LOADING.FINISH);
      
      if (success || (res.error && res.error.statusCode === 404)) {
        bus.emit(constants.EVENTS.NOTIFICATION.UPDATED, { success: true });
        bus.emit(constants.EVENTS.NOTIFICATION.LIST_ALL.REFRESH);
      } else {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Echec de l\'opération',
          body: res.error?.message || res.data?.message || 'Erreur inconnue'
        });
        bus.emit(constants.EVENTS.NOTIFICATION.UPDATED, { success: false });
      }
    }
  });
}
